module.exports = __webpack_public_path__ + "static/media/(V)_MG_5387_-_Pro-Natura_-_Moda_Feminina_-_Acessorios.e8f0df3b.jpg";